module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-practice-office",
    attrs: {
      "id": "office-tour"
    }
  }, [_c('div', {
    staticClass: "custom-practice-office__container"
  }, [_c('div', {
    staticClass: "custom-practice-office__office-row"
  }, [_c('div', {
    staticClass: "custom-practice-office__office-video",
    style: ({
      backgroundImage: 'url(' + _vm.props.video_img + ')'
    }),
    on: {
      "click": _vm.openVideo
    }
  }, [_c('div', {
    staticClass: "custom-practice-office__overlay"
  }, [_c('Icon', {
    staticClass: "custom-practice-office__icon",
    attrs: {
      "name": "triangle"
    }
  })], 1)])]), _vm._m(0), _c('div', {
    staticClass: "custom-practice-office__gallery"
  }, _vm._l((_vm.props.gallery), function(image, i) {
    return _c('div', {
      key: i,
      staticClass: "custom-practice-office__image-container",
      on: {
        "click": function($event) {
          return _vm.openGallery(i)
        }
      }
    }, [_c('div', {
      staticClass: "custom-practice-office__image",
      style: ({
        backgroundImage: 'url(' + image.url + ')'
      })
    })])
  }), 0)]), _c('transition', {
    staticClass: "custom-practice-office__transition",
    attrs: {
      "name": "fade-in-out"
    }
  }, [(_vm.showGallery) ? _c('div', {
    staticClass: "custom-practice-office__gallery-modal"
  }, [_c('div', {
    staticClass: "custom-practice-office__gallery-modal-overlay"
  }, [_c('div', {
    staticClass: "custom-practice-office__gallery-modal-container"
  }, [_c('div', {
    staticClass: "custom-practice-office__gallery-modal-close",
    on: {
      "click": _vm.closeGallery
    }
  }, [_c('span'), _c('span')]), _c('div', {
    staticClass: "custom-practice-office__gallery-modal-content"
  }, [_c('swiper', {
    ref: "mySwiper",
    staticClass: "custom-practice-office__slider-container",
    attrs: {
      "options": _vm.swiperOption
    }
  }, _vm._l((_vm.props.gallery), function(slide, j) {
    return _c('swiper-slide', {
      key: j,
      staticClass: "custom-practice-office__slide",
      style: ({
        backgroundImage: 'url(' + slide.url + ')'
      })
    })
  }), 1), _c('div', {
    staticClass: "custom-practice-office__next",
    on: {
      "click": _vm.slideNext
    }
  }, [_c('Icon', {
    attrs: {
      "name": "arrow-down"
    }
  })], 1), _c('div', {
    staticClass: "custom-practice-office__prev",
    on: {
      "click": _vm.slidePrev
    }
  }, [_c('Icon', {
    attrs: {
      "name": "arrow-down"
    }
  })], 1)], 1)])])]) : _vm._e()]), _c('Icon', {
    staticClass: "custom-practice-office__footer-divider",
    attrs: {
      "name": "patient-top-blue"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-practice-office__office-row"
  }, [_c('div', {
    staticClass: "custom-practice-office__resp-container"
  }, [_c('iframe', {
    staticClass: "custom-practice-office__overlay",
    attrs: {
      "allowfullscreen": "",
      "src": "https://tourmkr.com/G1TrB8nlbG"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f639a73","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-practice-office/custom-practice-office-bloomingdale/custom-practice-office-bloomingdale.pug
// module id = 669
// module chunks = 1